/** True when the gateway string is any Dejavoo variant (e.g. DEJAVOO, DejavooPOS). */
export const isDejavooGateway = (gateway) => {
  if (gateway == null || gateway === "") return false;
  return String(gateway).toUpperCase().includes("DEJAVOO");
};

/**
 * Get the gateway to use for a given payment method when company has separate gateways for Card vs ACH.
 * @param {Object} tokenData - Auth/token data with Gateway, GatewayCard, GatewayAch
 * @param {string} paymentMethod - e.g. "Credit/debit card", "card", "ACH bank payment", "ach", "Apple Pay", "Google Pay"
 * @returns {string} Uppercase gateway (e.g. "DEJAVOO", "NMI") for that payment type
 */
export const getGatewayForPaymentMethod = (tokenData, paymentMethod) => {
  if (!tokenData) return "";
  const pm = (paymentMethod || "").toString().toLowerCase();
  const isCard =
    pm === "card" ||
    pm === "credit/debit card" ||
    pm === "apple pay" ||
    pm === "google pay";
  const isAch = pm === "ach" || pm === "ach bank payment";
  if (isCard)
    return (tokenData.GatewayCard || tokenData.Gateway || "").toString().toUpperCase();
  if (isAch)
    return (tokenData.GatewayAch || tokenData.Gateway || "").toString().toUpperCase();
  return (tokenData.Gateway || "").toString().toUpperCase();
};

/**
 * Normalize payment gateway for display.
 * All Dejavoo variants (DEJAVOO, DejavooPOS, Dejavoo, etc.) show as "DejavooIPOS".
 */
export const formatGatewayDisplay = (gateway) => {
  if (gateway == null || gateway === "") return "—";
  const u = String(gateway).trim().toUpperCase();
  if (isDejavooGateway(u)) return "DejavooIPOS";
  if (u.includes("NMI")) return "Nmi";
  if (u.includes("PAYA")) return "PAYA";
  return String(gateway).trim() || "—";
};

/** Format card number for display: space every 4 digits (e.g. 4111 1111 1111 1111). Use in all Dejavoo CC fields. Min 13, max 19 digits (standard card rules). */
export const formatCardNumberDisplay = (value) => {
  if (value == null) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 19);
  return digits.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
};

/** Format expiry for display: MM/YY with slash (e.g. 0329 → 03/29). Store 4 digits (MMYY). */
export const formatExpiryDisplay = (value) => {
  if (value == null) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
};
